<template>
    <van-card
        @click="goDetail(item)"
        :key="item.id"
        :price="item.settle_amount"
        :title="item.prd_name + (item.version_name=='标准版'? '' : item.version_name)"
        :num="item.qty"
        :thumb="item.imgurl"
        class="order-item">
        <div slot="tags" class="tags">
            <van-tag type="primary">{{ item.cls_name }}{{ item.cls1_name }}</van-tag>
            <van-tag type="danger">{{ item.order_state_name }}</van-tag>
        </div>
        <div slot="desc">
            <div>{{ item.create_date | moment("YYYY-MM-DD HH:mm:ss") }}</div>
            <div>{{ item.brand_name }}</div>
            <div>{{ item.product_spc }}</div>
            <div>{{ item.product_barcode }}</div>
        </div>
    </van-card>
</template>

<script>
import {
    Card,
    Tag
} from 'vant'
export default {
    name: 'OrderItem',
    props: ['item'],
    components: {
        [Card.name]: Card,
        [Tag.name]: Tag
    },
    methods: {
        goDetail(item) {
            this.$emit('pick', item)
        }
    }
}
</script>

<style lang="less" scoped>
.order-item {
    .tags {
        .van-tag {
        margin-right: 4px;
        }
    }
}
</style>